import { FaGithub, FaLinkedin, FaYoutube, FaEnvelope } from 'react-icons/fa';
import { usePortfolio } from '../context/PortfolioContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { portfolioData } = usePortfolio();
  const footerData = portfolioData?.footer || {
    name: 'Dhiraj TH',
    title: 'AI Engineer & Innovator',
    email: 'contactdhirajth@gmail.com',
    links: {
      github: 'https://github.com/dhiraj-th',
      linkedin: 'https://linkedin.com/in/dhiraj-th',
      youtube: 'https://youtube.com/@dhiraj-th'
    },
    quickLinks: [
      { name: 'Home', href: '#home' },
      { name: 'About', href: '#about' },
      { name: 'Work', href: '#work' },
      { name: 'Collaborate', href: '#collaborate' }
    ]
  };

  return (
    <footer className="bg-secondary py-12">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-6 md:mb-0">
            <h2 className="text-2xl font-bold text-white">
              <span className="text-primary">D</span>hiraj TH
            </h2>
            <p className="text-gray-300 mt-2">{footerData.title}</p>
          </div>
          
          <div className="flex flex-col md:flex-row gap-8 mb-8 md:mb-0">
            <div>
              <h3 className="text-white font-medium mb-3">Quick Links</h3>
              <ul className="space-y-2">
                {footerData.quickLinks.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href} 
                      className="text-gray-300 hover:text-primary transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-medium mb-3">Contact</h3>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-gray-300">
                  <FaEnvelope className="text-primary" />
                  <span>{footerData.email}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 mt-8 border-t border-gray-700">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} {footerData.name}. All rights reserved.
          </p>
          
          <div className="flex items-center gap-6">
            {footerData.links.github && (
              <a 
                href={footerData.links.github}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label="GitHub"
              >
                <FaGithub size={20} />
              </a>
            )}
            {footerData.links.linkedin && (
              <a 
                href={footerData.links.linkedin}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <FaLinkedin size={20} />
              </a>
            )}
            {footerData.links.youtube && (
              <a 
                href={footerData.links.youtube}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label="YouTube"
              >
                <FaYoutube size={20} />
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 